/**
 * =============================================================================
 * Super A Sports — product page gallery: "1 / 3" counter under the slider
 * =============================================================================
 * Client request (2026-10-28): one photo at a time with previous / next arrows
 * and a position counter, like their old site. The slider itself is
 * WooCommerce's FlexSlider (arrows on, thumbnails off — inc/Shop/ProductImages),
 * styled in scss/woo/_single-product-gallery.scss. This module only adds the
 * counter.
 *
 * FlexSlider is jQuery and fires no DOM events; it marks the photo on screen
 * with `.flex-active-slide`. A MutationObserver on the gallery picks up both
 * the slider being built (it inserts `.flex-viewport`) and every slide change —
 * arrows, swipes, and WooCommerce resetting to the first photo when a
 * variation is chosen — without touching jQuery.
 *
 * One photo = no counter (the slider does not start, there is nothing to count).
 * =============================================================================
 */

const GALLERY = ".woocommerce-product-gallery:not(.woocommerce-product-gallery--without-images)";
const SLIDE = ".woocommerce-product-gallery__image";

function attach(gallery) {
	const slides = gallery.querySelectorAll(SLIDE);
	if (slides.length < 2) {
		return;
	}

	const counter = document.createElement("div");
	counter.className = "sa-gallery-count";
	counter.setAttribute("aria-live", "polite");
	gallery.appendChild(counter);

	const update = () => {
		// FlexSlider appends its viewport and arrows to the end of the
		// gallery when it starts — keep the counter below them.
		if (gallery.lastElementChild !== counter) {
			gallery.appendChild(counter);
		}

		const all = gallery.querySelectorAll(SLIDE);
		let current = 0;
		all.forEach((slide, index) => {
			if (slide.classList.contains("flex-active-slide")) {
				current = index;
			}
		});
		const text = `${current + 1} / ${all.length}`;
		if (counter.textContent !== text) {
			counter.textContent = text;
		}
	};

	update();
	new MutationObserver(update).observe(gallery, {
		subtree: true,
		childList: true,
		attributes: true,
		attributeFilter: ["class"],
	});
}

export function initProductGallery() {
	document.querySelectorAll(GALLERY).forEach(attach);
}
